import {get, postJson} from '@/coreConfig/fetchMiddleware';
import {
    getServiceInfoApi,
    getApplyAddApi,
    getApplyStatusApi,
} from '@/coreConfig/api';

// 3.1. 服务管理/用户状态接口
export const fetchServiceInfo = () => get(`${getServiceInfoApi}`);

// 3.2. 申请试用接口
// 3.2.1. 申请状态
export const fetchApplyStatus = () => get(`${getApplyStatusApi}`);

// 3.2.2. 提交申请
export const fetchApplyAdd = (data: any) => postJson(`${getApplyAddApi}`, data);
